import React, { useState, useEffect } from 'react'
import { Tree } from 'primereact/tree'
import PropTypes from 'prop-types'
import styles from '../../css/generals/Tree.module.css'
import { useTranslation } from 'react-i18next'

export default function SelectionTree ({ selection, setSelectecTree }) {
  const { t } = useTranslation('roles')
  const [nodes, setNodes] = useState([])

  const items = [
    {
      key: '0',
      label: t('treeJson.one'),
      icon: 'pi pi-fw pi-check-square',
      children: [
        {
          key: '1',
          label: t('treeJson.two'),
          icon: 'pi pi-home'
        },
        {
          key: '2',
          label: t('treeJson.three'),
          icon: 'pi pi-tablet',
          children: [
            {
              key: '2-0',
              label: t('treeJson.four'),
              icon: 'pi pi-circle'
            }
          ]
        },
        {
          key: '3',
          label: t('treeJson.five'),
          icon: 'pi pi-users',
          children: [
            {
              key: '3-0',
              label: t('treeJson.four'),
              icon: 'pi pi-circle'
            }
          ]
        },
        {
          key: '4',
          label: t('treeJson.six'),
          icon: 'pi pi-user'
        },
        {
          key: '5',
          label: t('treeJson.seven'),
          icon: 'pi pi-tags'
        },
        {
          key: '6',
          label: t('treeJson.eight'),
          icon: 'pi pi-map-marker'
        },
        {
          key: '7',
          label: t('treeJson.nine'),
          icon: 'pi pi-th-large'
        },
        {
          key: '8',
          label: t('treeJson.ten'),
          icon: 'pi pi-fw pi-wrench',
          children: [
            {
              key: '8-0',
              label: t('treeJson.eleven'),
              icon: 'pi pi-circle'
            },
            {
              key: '8-1',
              label: t('treeJson.twelve'),
              icon: 'pi pi-circle'
            },
            {
              key: '8-2',
              label: t('treeJson.thirteen'),
              icon: 'pi pi-circle'
            },
            {
              key: '8-3',
              label: t('treeJson.fourteen'),
              icon: 'pi pi-circle'
            },
            {
              key: '8-4',
              label: t('treeJson.eight'),
              icon: 'pi pi-circle'
            },
            {
              key: '8-5',
              label: t('treeJson.fifteen'),
              icon: 'pi pi-circle'
            },
            {
              key: '8-6',
              label: t('treeJson.sixteen'),
              icon: 'pi pi-circle'
            },
            {
              key: '8-7',
              label: t('treeJson.thirty'),
              icon: 'pi pi-circle'
            }
          ]
        },
        {
          key: '9',
          label: t('treeJson.twelve'),
          icon: 'pi pi-copy'
        },
        {
          key: '10',
          label: t('treeJson.twenty-nine'),
          icon: 'pi pi-building'
        },
        {
          key: '11',
          label: t('treeJson.twenty-six'),
          icon: 'pi pi-calendar',
          children: [
            {
              key: '11-0',
              label: t('treeJson.twenty-seven'),
              icon: 'pi pi-circle'
            },
            {
              key: '11-1',
              label: t('treeJson.twenty-eight'),
              icon: 'pi pi-circle'
            }
          ]
        }/*,
        {
          key: '10',
          label: 'Safeweb',
          icon: 'pi pi-fw pi-shield',
          children: [
            {
              key: '10-0',
              label: 'Inicio',
              icon: 'pi pi-circle'
            },
            {
              key: '10-1',
              label: 'Listas',
              icon: 'pi pi-circle'
            },
            {
              key: '10-2',
              label: 'Palabras claves',
              icon: 'pi pi-circle'
            },
            {
              key: '10-3',
              label: 'Preferencias',
              icon: 'pi pi-circle'
            }
          ]
        } */
      ]
    }
  ]

  useEffect(() => {
    setNodes(items)
  }, [setNodes])

  return (
    <div className={styles.treeContainer}>
        <Tree
            value={nodes}
            selectionMode="single"
            selectionKeys={selection}
            onSelectionChange={(e) => setSelectecTree(e.value)}
        />
    </div>
  )
}

SelectionTree.propTypes = {
  selection: PropTypes.string,
  setSelectecTree: PropTypes.func
}
